const p = (e) => e && typeof e == "object" && !Array.isArray(e), a = (e, ...n) => {
  const r = { ...e };
  return n.forEach((o) => {
    p(e) && p(o) && Object.keys(o).forEach((t) => {
      p(o[t]) ? t in e ? r[t] = a(e[t], o[t]) : Object.assign(r, { [t]: o[t] }) : Object.assign(r, { [t]: o[t] });
    });
  }), r;
}, u = (e, n, r) => {
  const o = n;
  e.length && e.forEach((t) => {
    const {
      componentName: i,
      modelVariation: c,
      variant: s,
      update: l = null,
      additionalVariantData: d
      // includes sortedActivities, propensity and others
    } = t, g = !!i && !!n[i], A = !!c && !!n[c];
    if (g && s) {
      const f = { variant: s, ...d };
      A ? o[i] = l ? a(
        n[i],
        n[c],
        f
      ) : a(
        n[c],
        f
      ) : o[i] = a(
        n[i],
        f
      );
    }
  }), r(o);
}, w = () => typeof window < "u" ? window.adobe : void 0, y = (e, n, r, o = { mbox: "target-global-mbox" }) => {
  const t = w();
  return t != null && t.target ? t.target.getOffer({
    ...o,
    success: (i) => {
      const c = i.filter((s) => (s == null ? void 0 : s.action) === "setJson");
      c.length ? c.forEach((s) => {
        const { content: l } = s;
        Array.isArray(l) && l.forEach((d) => {
          u(d, e, n);
        });
      }) : n();
    },
    error: () => {
      r();
    }
  }) : r();
}, h = (e) => {
  var o;
  if (!e || !e.execute)
    return console.error("Invalid or missing Adobe Target data structure:", e), null;
  const { execute: { pageLoad: n, mboxes: r } } = e;
  return (o = n == null ? void 0 : n.options) != null && o.length ? n.options : r != null && r.length ? r : (console.info("Unsupported structure in adobeTargetEWData:", e), null);
}, b = (e) => {
  const n = document.getElementById(e);
  if ((() => n !== null && n.innerHTML !== "")())
    try {
      return JSON.parse(n.innerHTML);
    } catch (o) {
      return console.error(`Error parsing JSON from script with ID ${e}:`, o), !1;
    }
  return console.info(`Script element with ID '${e}' not found.`), !1;
}, m = (e, n, r) => {
  const t = b("ew-adobe-target-data");
  if (t) {
    const i = h(t);
    if (i != null && i.length) {
      const c = i.reduce((s, l) => (l.type === "json" && Array.isArray(l.content) && s.push(...l.content), s), []);
      if (c.length) {
        u(c, e, n);
        return;
      }
    }
    n(e);
  } else
    r();
}, O = (e = ["__view__"], n = {}) => new Promise((r, o) => {
  const t = {
    decisionScopes: [...e],
    ...n
  }, i = t.decisionScopes.map((s) => ({ scope: s })), c = {
    ...t.xdm,
    _experience: {
      decisioning: {
        propositions: i,
        propositionEventType: {
          display: 1
        }
      }
    },
    eventType: "decisioning.propositionDisplay"
  };
  typeof window.alloy < "u" ? window.alloy("sendEvent", {
    ...t,
    xdm: c
  }).then(({ propositions: s }) => {
    if (!(s != null && s.length)) {
      r([]);
      return;
    }
    const l = s.filter((d) => t.decisionScopes.includes(d.scope)).flatMap((d) => d.items).map((d) => d.data).filter((d) => d && d.content);
    r(l);
  }).catch(() => {
    o(new Error("Could not retrieve Adobe Target Propositions"));
  }) : o(new Error("Adobe Alloy not defined"));
}), E = (e = "target-global-mbox", n = {}) => new Promise((r, o) => {
  typeof window.adobe < "u" && window.adobe.target ? window.adobe.target.getOffer({
    mbox: e,
    params: n,
    success: (t) => {
      if (Array.isArray(t)) {
        const i = t.filter((c) => c.action === "setJson");
        r(i);
      }
      r([]);
    },
    error: () => {
      o(new Error("Could not retrieve Adobe Target JSON Offer"));
    }
  }) : o(new Error("adobe API not defined"));
});
export {
  E as getAdobeTargetJsonOffer,
  y as getAndApplyAdobeTargetOffers,
  m as getAndApplyEWContent,
  O as getPropositions
};
